/**
 * @fileoverview GET handler for the "/users/subscription_group_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { SubscriptionGroupBase } from "../usersSubscriptionGroupsData";
import { usersSubscriptionGroupData } from "./constants";

export const getUsersSubscriptionGroupData = reactQueryFetcherAdapter(
  usersSubscriptionGroupData,
  (signal: AbortSignal, id: string): Promise<SubscriptionGroupBase> => {
    return fetch("/users/subscription_group_data", "GET", { id }, { signal });
  }
);
